import Swal from "sweetalert2";
export const showErrors = (errors) => {
  Swal.fire({
    icon: "warning",
    html: getError(errors),
  });
};

const getError = (errors) => {
  let keys = Object.keys(errors);
  let li = "";

  for (let i = 0; i < keys.length; i++) {
    li = li + "<li>" + eval("errors." + keys[i]) + "</li>";
  }
  return li;
};
export const alertSuccess = (text) => {
  const Toast = Swal.mixin({
    toast: true,
    background: "#ffffff",
    position: "top-end",
    showConfirmButton: false,
    timer: 4000,
  });

  Toast.fire({
    icon: "success",
    title: text,
  });
};
export const alertInfo = (text, withTime = true) => {
  const Toast = Swal.mixin({
    toast: true,
    background: "#ffffff",
    position: "top-end",
    showConfirmButton: false,
    timer: withTime ? 4000 : 0,
  });

  Toast.fire({
    icon: "info",
    title: text,
  });
};
export const alertWarning = (text) => {
  const Toast = Swal.mixin({
    toast: true,
    background: "#e4e4e4",
    position: "top-end",
    showConfirmButton: false,
    timer: 4000,
  });

  Toast.fire({
    icon: "warning",
    title: text,
  });
};
export const alertError = (text) => {
  const Toast = Swal.mixin({
    toast: true,
    background: "#e4e4e4",
    position: "top-end",
    showConfirmButton: false,
    timer: 4000,
  });

  Toast.fire({
    icon: "error",
    title: text,
  });
};
export const showAlert = (
  title,
  text,
  actionTrue = null,
  actionFalse = null
) => {
  Swal.fire({
    icon: "warning",
    title: title,
    text: text,
    showCancelButton: true,
    confirmButtonColor: "var(--strong-blue)",
    cancelButtonColor: "var(--strong-blue)",
    cancelButtonText: "Cancelar",
    confirmButtonText: "Aceptar",
  }).then((result) => {
    if (result.value) {
      actionTrue && actionTrue();
    } else {
      actionFalse && actionFalse();
    }
  });
};

/**
 * Show a confirmation alert.
 * @param {string} title - Title of the alert (e.g: "¿Eliminar proveedor?")
 * @param {string} text - Additional text (e.g: "Esta acción no se puede deshacer.")
 * @param {function} onConfirm - Callback when the user confirms
 */
export const confirmDelete = (title, text, onConfirm) => {
  Swal.fire({
    icon: "warning",
    title: title || "¿Está seguro?",
    text: text || "Esta acción no se puede deshacer.",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#6c757d",
    cancelButtonText: "Cancelar",
    confirmButtonText: "Sí, eliminar",
  }).then((result) => {
    if (result.isConfirmed) onConfirm?.();
  });
};
export const showTypeErrorFetch = (e) => {
  if (e.request.status === 401) {
    window.reload();
  } else if (e.request.status === 422) {
    showErrors(e.response.data);
  } else if (e.request.status === 403) {
    alertWarning("No autorizado");
  } else {
    alertError("Error inesperado");
  }
};
